import { LucidePackageOpen } from "lucide-react";
import './emptydisplay.scss'

type Props={
    text:string,
    icon_class:string
}

const EmptyDisplay = ({text,icon_class}:Props) => {
    return (<div className='emptydisplay'>
        <div className='idiv'>
            <LucidePackageOpen size={70} strokeWidth={0.8} className='bigcart'></LucidePackageOpen>
          
            <div className='text'>{text}</div>
        </div>
    </div>)
}


export default EmptyDisplay;